import { Component, OnInit } from '@angular/core';
import { OktaAuthService } from 'axis-components/components/okta-auth/services/okta-auth.service';

@Component({
  selector: 'axis-okta-callback',
  template: `<div>Loading...</div>`
})
export class LoginCallbackComponent implements OnInit {

  constructor(private oktaAuthService: OktaAuthService) { }

  async ngOnInit() {
    // Handles the response from Okta and parses tokens
    await this.oktaAuthService.handleAuthentication();
  }

}
